import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "dua-not-authorized",
  templateUrl: "./not-authorized.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotAuthorizedComponent implements OnInit, OnDestroy {
  private loggedInSubscription = Subscription.EMPTY;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    this.loggedInSubscription = this.authService.loggedInStatusChanged.subscribe(
      (isLoggedIn) => {
        if (isLoggedIn) {
          this.router.navigateByUrl("/dua");
        }
      }
    );
  }

  ngAfterViewInit() {
    if (this.authService.getIsLoggedIn()) {
      this.router.navigateByUrl("/dua");
    }
  }

  login() {
    this.authService.login();
  }

  ngOnDestroy(): void {
    this.loggedInSubscription.unsubscribe();
  }
}
